<template>
  <div>
    <div class="gosBox" v-if="flagBox == 2">
      <van-icon name="arrow-left" size="24px" @click="gos(1)" />
    </div>
    <div class="register-container">
      <!-- <img style="width: 100%" src="../assets/topbg.png" > -->
      <div class="content topBox">
        <img style="width: 20%" src="../assets/stPay2.jpg" />
        <p>Register Ant</p>
      </div>
      <div class="content" v-if="flagBox == 1">
        <div class="box">
          <div class="put">
            <van-form validate-first @failed="onFailed">
              <van-field
                label-width="36px"
                label="+91"
                v-model="memberPhone"
                type="tel"
                placeholder="Please enter phone number"
                :rules="[
                  {
                    pattern: /^[6-9]\d{9}$/,
                    message:
                      'Please enter the correct mobile phone number format.',
                  },
                ]"
              />
            </van-form>
          </div>
        </div>
        <div class="box">
          <div class="put">
            <van-field
              v-model="memberPwd"
              :type="passwordType"
              placeholder="Please enter password"
            >
              <template slot="left-icon">
                <span class="solts">
                  <van-icon name="lock" size="20px" />
                </span>
              </template>
              <template slot="right-icon">
                <span class="solts" @click="switchPasswordType">
                  <van-icon name="eye" v-if="passwordType === 'text'" />
                  <van-icon name="closed-eye" v-else />
                </span>
              </template>
            </van-field>
          </div>
        </div>
        <div class="box">
          <div class="put">
            <van-field
              v-model="memberPwdAgain"
              :type="passwordType1"
              placeholder="Please enter password again"
            >
              <template slot="left-icon">
                <span class="solts">
                  <van-icon name="lock" size="20px" />
                </span>
              </template>
              <template slot="right-icon">
                <span class="solts" @click="switchPasswordType1">
                  <van-icon name="eye" v-if="passwordType1 === 'text'" />
                  <van-icon name="closed-eye" v-else />
                </span>
              </template>
            </van-field>
          </div>
        </div>
        <div class="box">
          <div class="put">
            <van-field v-model="inviteCode" disabled class="custom-green-text">
              <template #left-icon>
                <van-icon name="cluster" class="field-icon" />
              </template>
            </van-field>
            <!-- placeholder="Please enter invite code" -->
          </div>
        </div>
        <div class="box">
          <div class="put">
            <van-field
              v-model="memberEmail"
              placeholder="Please enter your Email"
              :rules="[
                {
                  pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: 'The email format is incorrect',
                },
              ]"
            >
              <template #left-icon>
                <img src="../assets/email.jpg" style="width: 24px" />
              </template>
            </van-field>
          </div>
        </div>
        <van-button
          @click="gos(2)"
          style="
            margin-top: 40px;
            height: 48px;
            font-family: Source Sans Variable;
            font-weight: bold;
            font-size: 24px;
            border-radius: 20px;
            color: #fff;
          "
          color="#2a28ff"
          :disabled="isDisabled"
          block
          >SIGN UP</van-button
        >
        <p
          style="
            margin-top: 24px;
            text-align: center;
            font-family: Source Sans Variable;
            color: #2a28ff;
            font-size: 14px;
          "
        >
          Already have an account?
        </p>
      </div>
      <div class="content boxTwo" v-if="flagBox == 2">
        <p>OTP Verification</p>
        <p>we have sent an OTP to your registered Email address</p>
        <p>
          <span
            style="background: #d6d6d6; padding: 8px 24px; border-radius: 15px"
          >
            {{ memberEmail }}
          </span>
        </p>
        <div class="box" style="margin-top: 50px">
          <div class="put">
            <van-field
              v-model="verificationCode"
              placeholder="Please enter OTP"
            >
              <template #left-icon>
                <img src="../assets/otp.jpg" style="width: 24px" />
              </template>

              <template #button>
                <span
                  class="timer-badge"
                  :class="{ disabled: isCounting }"
                  @click="sendCode"
                >
                  <!-- 根据状态显示文字：正在倒计时显示数字，否则显示'点击' -->
                  {{ isCounting ? `${countDown}s` : "Re-sent" }}
                </span>
              </template>
            </van-field>
          </div>
        </div>
        <p
          style="
            margin-top: 24px;
            text-align: center;
            font-family: Source Sans Variable;
            color: #2a28ff;
            font-size: 14px;
          "
        >
          Didnt Receive the code? Resend in {{ countDown }} Seconds
        </p>
        <van-button
          @click="submit"
          style="
            margin-top: 20px;
            height: 48px;
            font-family: Source Sans Variable;
            font-weight: bold;
            font-size: 24px;
            border-radius: 20px;
            color: #fff;
          "
          color="#2a28ff"
          :disabled="isDisabledTwo"
          block
          >Verify OTP</van-button
        >
      </div>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper" @click.stop>
          <van-loading type="spinner" color="#1989fa" />
        </div>
      </van-overlay>
    </div>
    <van-popup round style="width: 90%" v-model="success">
      <div class="dialog-content">
        <div class="app-icon">
          <img src="../assets/stPay2.jpg" />
          <p>ANT</p>
        </div>
        <van-button color="#282c38" class="vb" @click="downloadApp">
          <span style="font-weight: 600; color: #fff; font-size: 18px">
            Download ANT</span
          >
        </van-button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { captcha, register, sendOtp } from "@/api";
import { Button } from "vant";
import Vue from "vue";
Vue.use(Button);
import { Popup } from "vant";
Vue.use(Popup);
import { Field } from "vant";
Vue.use(Field);
import { Form } from "vant";
Vue.use(Form);
import { Icon } from "vant";
Vue.use(Icon);
import { Image as VanImage } from "vant";
Vue.use(VanImage);
import { Loading } from "vant";
import { Overlay } from "vant";
Vue.use(Overlay);
Vue.use(Loading);
import { Notify } from "vant";
Vue.use(Notify);
export default {
  data() {
    return {
      memberPhone: "",
      memberPwd: "",
      memberPwdAgain: "",
      passwordType: "text",
      passwordType1: "text",
      inviteCode: "",
      img: "",
      downloadLink: "",
      show: false,
      success: false,
      memberEmail: "",
      flagBox: 1,
      verificationCode: "",

      countDown: 30, //倒计时
      timer: null,

      isCounting: false,
    };
  },
  computed: {
    isDisabled() {
      return (
        this.memberPhone == "" ||
        this.memberPwd == "" ||
        this.memberPwd.length < 6 ||
        this.memberPwdAgain == "" ||
        this.memberPwdAgain.length < 6 ||
        this.inviteCode == "" ||
        this.memberEmail == ""
      );
    },
    isDisabledTwo() {
      return this.verificationCode == "";
    },
  },
  methods: {
    downloadApp() {
      // 直接在新标签页中打开文件链接
      window.open(this.downloadLink, "_blank");
    },

    onFailed(errorInfo) {
      console.log("failed", errorInfo);
    },

    gos(num) {
      this.flagBox = num;
      this.sendCode();
    },
    submit() {
      this.show = true;
      let params = {
        memberPhone: this.memberPhone,
        memberPwd: this.memberPwd,
        memberPwdAgain: this.memberPwdAgain,
        inviteCode: this.inviteCode,
        memberEmail: this.memberEmail,
        verificationCode: this.verificationCode,
      };
      register(params, {
        packageName: "com.wxl.pay.ant",
      })
        .then((res) => {
          if (res.downloadLink) {
            this.success = true;
            this.downloadLink = res.downloadLink;
          } else {
            Notify({ type: "warning", message: res.message });
          }
          this.show = false;
        })
        .catch((err) => {
          console.log("🚀 ~ submit ~ err:", err);
          this.show = false;
          Notify({ type: "warning", message: err.message });
        });
    },

    switchPasswordType() {
      this.passwordType =
        this.passwordType === "password" ? "text" : "password";
    },
    switchPasswordType1() {
      this.passwordType1 =
        this.passwordType1 === "password" ? "text" : "password";
    },
    submitForm() {
      // Logic to handle form submission
      console.log("Form submitted", this.form);
    },
    goToLogin() {
      // Logic to navigate to login page
      this.$router.push("/login");
    },

    // 发送验证码
    sendCode() {
      // 如果正在倒计时，点击无效，直接返回
      console.log(this.isCounting);

      if (this.isCounting) return;
      let params = {
        sendTo: this.memberEmail, //邮箱
        codeType: "5", //类型：5-注册
      };
      sendOtp(params, {
        packageName: "com.wxl.pay.ant",
      })
        .then((res) => {
          // 模拟发送请求
          Notify({ type: "success", message: "Success" });
          // 开始倒计时
          this.startTimer();
        })
        .catch((err) => {});
    },

    startTimer() {
      this.isCounting = true;
      this.countDown = 30; // 重置时间

      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          // 倒计时结束
          this.isCounting = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
  created() {},
  mounted() {
    this.inviteCode = this.$route.query.num;
  },
};
</script>

<style scoped>
.register-container {
  padding-bottom: 60px;
}

.gosBox {
  height: 30px;
  padding: 20px 20px 0;
}

.topBox {
  margin-top: 30px;
  display: flex;
  align-items: center;
}

.topBox p {
  margin-left: 18px;
  font-size: 20px;
}

.content {
  padding: 0 30px;
}
.box {
  margin-top: 20px;
}
.zi {
  font-family: Source Sans Variable;
  font-weight: 600;
  color: #666666;
  margin-bottom: 12px;
}
.van-cell {
  background: rgba(109, 181, 254, 0);
  border-radius: 15px;
  border: 1px solid #eeeeee;
}
/deep/ .van-field__label {
  font-family: Source Sans Variable;
  font-weight: bold;
  font-size: 15px;
  color: #666666;
}
.van-button__text {
  color: #000;
}
/deep/ .van-field__control {
  font-family: Source Sans Variable;
  font-weight: 600;
  color: #111111;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.success-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: linear-gradient(135deg, #6a11cb, #2575fc);
  color: white;
  text-align: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
}

.success-icon {
  font-size: 80px;
  color: #4caf50;
  margin-bottom: 20px;
}

.success-title {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 16px;
}

.success-description {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 40px;
}

/* 背景动画 - 彩带效果 */
.confetti {
  position: absolute;
  width: 10px;
  height: 10px;
  background-color: #ffeb3b;
  top: -10%;
  animation: confetti-fall 5s linear infinite;
}

.confetti:nth-child(2) {
  background-color: #f44336;
  left: 20%;
  animation-delay: 1s;
}

.confetti:nth-child(3) {
  background-color: #2196f3;
  left: 40%;
  animation-delay: 2s;
}

.confetti:nth-child(4) {
  background-color: #4caf50;
  left: 60%;
  animation-delay: 3s;
}

.confetti:nth-child(5) {
  background-color: #ff9800;
  left: 80%;
  animation-delay: 4s;
}

@keyframes confetti-fall {
  0% {
    transform: translateY(0) rotate(0deg);
  }
  100% {
    transform: translateY(100vh) rotate(720deg);
  }
}
.dialog-content {
  text-align: center;
  padding: 20px;
}

.app-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
}

.app-icon img {
  width: 50px;
  height: 50px;
}
.app-icon p {
  margin-top: 16px;
}
.title-container {
  width: 100%;
  padding-top: 20px;
}

.title {
  font-size: 1.3rem;
  position: relative;
  display: inline-block;
  color: #000; /* 标题文字的颜色 */
}

.title span {
  display: inline-block;
  position: relative;
  z-index: 1; /* 确保文字在背景色之上 */
}

.title::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%; /* 控制绿色背景的高度 */
  background-color: #66cc33; /* 背景色 */
  z-index: 0; /* 确保背景色在文字下面 */
}
.ds {
  margin-top: 12px;
  color: #8d8d8d;
  font-size: 12px;
}
.vb {
  width: 100%;
  border-radius: 12px;
}
.custom-green-text ::v-deep .van-field__control:disabled {
  color: #3720ff;
  -webkit-text-fill-color: #3720ff;
}

.van-button__text {
  color: #fff;
}

.boxTwo p {
  text-align: center;
}
.boxTwo > p:nth-child(1) {
  margin-top: 40px;
  font-size: 24px;
  font-weight: bold;
}
.boxTwo > p:nth-child(2) {
  margin-top: 16px;
  font-size: 12px;
}

.boxTwo > p:nth-child(3) {
  margin-top: 20px;
  font-size: 12px;
}

.field-icon {
  font-size: 20px;
  color: #000;
  font-weight: bold;
  margin-right: 5px;
}
/* 右侧倒计时胶囊样式 */
.timer-badge {
  display: inline-block;
  background-color: #969799; /* 深灰色背景 */
  color: #fff;
  font-size: 13px;
  padding: 4px 10px;
  border-radius: 12px; /* 圆角胶囊形状 */
  min-width: 40px;
  text-align: center;
}
</style>
